module.exports = __webpack_public_path__ + "static/media/1POLICY25.d6636f78.jpg";